import { z } from 'zod';

/** 제안형 4탭 카운트 — BE camelCase */
export const GetSeedingMeProposalCountServiceResponseSchema = z
  .object({
    pending: z.number().nonnegative(),
    confirmed: z.number().nonnegative(),
    completed: z.number().nonnegative(),
    rejected: z.number().nonnegative(),
  })
  .describe('GetSeedingMeProposalCountServiceResponseSchema');

export type GetSeedingMeProposalCountServiceResponse = z.infer<
  typeof GetSeedingMeProposalCountServiceResponseSchema
>;
